import {useAPI} from "../../hooks/useAPI";
import {API_General} from "../../api/general";
import React, {useEffect} from "react";
import styled from "styled-components";
import {useAuth} from "../../hooks/auth.hook";
import {Link} from "react-router-dom";

export const FallbackPage = (props) => {


    return (
        <StyledFallbackPage>
            <h1>
                Упс! Что-то пошло не так.
            </h1>
            <h2> Мы уже работаем над исправлением этой проблемы.
            </h2>
            <a href="/">Вернуться</a>
        </StyledFallbackPage>
    )
}

const StyledFallbackPage = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    height: max-content;
    color: #009ff5;
    font-size: 44px;
    margin-bottom: 10px;

  }

  h2 {
    height: max-content;
    color: black;
    font-size: 26px;
  }

  a {
    margin-top: 20px;
    text-decoration: underline;
  }

  @media (max-width: 1100px) {
    h1 {
      height: max-content;
      color: #009ff5;
      font-size: 24px;
      text-align: center;
      margin-bottom: 10px;
    }

    h2 {
      height: max-content;
      color: black;
      font-size: 18px;
      text-align: center;
      margin-bottom: 10px;

    }

    a {
      text-decoration: underline;
      margin-bottom: 10px;

    }
  }
`